var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZhS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.333l3.667 9.167h-1.796l-1-2.5h-3.409l-.999 2.5H9.668l3.666-9.167H15zm-.833 2.405l-1.039 2.595h2.077l-1.038-2.595z",
    fill: "#AFB7C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.166 12.5v1.667a1.667 1.667 0 001.542 1.662l.125.004h2.5V17.5h-2.5a3.333 3.333 0 01-3.334-3.333V12.5h1.667zm10-10a3.333 3.333 0 013.333 3.333V7.5h-1.666V5.833a1.667 1.667 0 00-1.667-1.666h-2.5V2.5h2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.666 1.667v1.666h3.333v5.834H6.666v2.5H4.999v-2.5H1.666V3.333h3.333V1.667h1.667zM4.999 5H3.333v2.5h1.666V5zm3.334 0H6.666v2.5h1.667V5z"
  }))));
}
export default SvgZhS;